const Style = () => ({
  custom_customer__main: {
    padding: '24px',
    backgroundcolor: 'red',
    maxHeight: 'calc(100vh - 7rem)',
    overflow: 'scroll',
  },
  heading: {
    fontSize: '20px',
    fontWeight: '500',
    lineHeight: '23px',
    color: '#263238',
  },
  flex__field: {
    display: 'flex',
    flexDirection: 'column',
    width: '48% ',
  },

  fields__main: {
    display: 'flex',
    flexDirection: 'column',
  },
  label: {
    fontSize: '13px',
    fontWeight: '500',
    lineHeight: '20px',
    color: '#6D7D8B',
    padding: '1.5rem 0 .65rem',
  },
  data__field: {
    background: 'transparent',
    border: '1px solid #AEB6B7',
    borderRadius: '100px',
    height: '42px',
    marginRight: '.7rem',
    width: '100%',
    '& .MuiInputBase-root': {
      height: '100%',
      padding: '0 1rem',
      '& input': {
        height: '100%',
        fontSize: '13px',
        fontWeight: '500',
        color: '#000',
        padding: '0',
      },
    },
  },
  is__error__border: {
    borderColor: '#FF3636 !important',
  },
  is__error: {
    color: '#E53935',
  },
  is__error__underline: {
    borderBottom: '0.25px solid #e53935',
  },
  phone__field: {
    '& .react-tel-input': {
      '& .form-control': {
        paddingLeft: '33px',
        height: '42px',
        fontWeight: '600',
        fontSize: '13px !important',
        lineHeight: '18px',
        color: '#545b7d',
        width: '100%',
        marginTop: '0 !important',
        border: '1px solid #AEB6B7',
        background: 'transparent !important',
        borderRadius: '100px',
      },
      '& .arrow': {
        display: 'none',
      },
      '& .flag-dropdown': {
        border: 'none',
        background: 'transparent !important',
      },
      '& .selected-flag': {
        background: 'transparent !important',
        '&:hover': {
          background: 'transparent',
        },
        '&:focus': {
          background: 'transparent',
        },
      },
    },
  },
  additional__information: {
    backgroundColor: 'transparent',
    paddingTop: '1rem',
    width: '100%',
    '& .MuiButton-text': {
      color: '#6921C4',
      textDecoration: 'underline',
    },
    '& .MuiButton-root:hover': {
      backgroundColor: 'transparent',
    },
    '& .MuiButton-textPrimary:hover': {
      backgroundColor: 'transparent',
    },
  },
});
export default Style;
